<template>
<div class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
    <!-- <div class="dashboard_section">
		<div class="container-fluid">
			<div class="row">
				<nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block border-0 sidebar collapse">
                <div class="position-sticky pt-3">
                    <ul class="nav flex-column">
					<li class="nav-item">
                            <router-link class="nav-link " :to="{name: 'all_user_group'}" aria-current="page">
                                <span data-feather="home">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
  <path id="_Users_Role" data-name=" Users Role" d="M13,21V11h8V21ZM3,13V3h8V13Zm6-2V5H5v6ZM3,21V15h8v6Zm2-2H9V17H5Zm10,0h4V13H15ZM13,3h8V9H13Zm2,2V7h4V5Z" transform="translate(-3 -3)"/>
</svg>
                                </span>
                                Users Role
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link " :to="{name: 'all_user'}" aria-current="page">
                                <span data-feather="home">
                                    <svg id="_User" data-name=" User" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
  <path id="Path_9442" data-name="Path 9442" d="M0,0H18V18H0Z" fill="none"/>
  <path id="Path_9443" data-name="Path 9443" d="M4,18.25a6.571,6.571,0,1,1,13.143,0H15.5a4.929,4.929,0,0,0-9.857,0Zm6.571-7.393A4.929,4.929,0,1,1,15.5,5.929,4.927,4.927,0,0,1,10.571,10.857Zm0-1.643A3.286,3.286,0,1,0,7.286,5.929,3.285,3.285,0,0,0,10.571,9.214Z" transform="translate(-1.571 -1)"/>
</svg>
                                </span>
                                Users
                            </router-link>
                        </li>                        
                        <li class="nav-item">
                            <router-link class="nav-link " :to="{name: 'all_clients'}">
                                <span data-feather="shopping-cart">
                                     <svg id="Clients" xmlns="http://www.w3.org/2000/svg" width="17.28" height="18" viewBox="0 0 17.28 18">
  <path id="Path_118" data-name="Path 118" d="M0,0H17.28V17.28H0Z" transform="translate(0 0.72)" fill="none"/>
  <path id="Path_119" data-name="Path 119" d="M4,19a6.857,6.857,0,1,1,13.714,0Zm7.714-5.072v3.357h3.993A5.151,5.151,0,0,0,11.714,13.928ZM10,17.286V13.928a5.151,5.151,0,0,0-3.993,3.357Zm.857-6A5.143,5.143,0,1,1,16,6.143,5.141,5.141,0,0,1,10.857,11.286Zm0-1.714A3.429,3.429,0,1,0,7.429,6.143,3.428,3.428,0,0,0,10.857,9.571Z" transform="translate(-2.217 -1)"/>
</svg>
                                </span>
                                Clients
                            </router-link>
                        </li>
						<li class="nav-item">
                                <router-link class="nav-link" :to="{name: 'email_template'}" aria-current="page">
                                    <span data-feather="home">
                                       <svg id="Email_Templates" data-name="Email Templates" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
  <path id="Path_9444" data-name="Path 9444" d="M0,0H18V18H0Z" fill="none"/>
  <path id="Path_9445" data-name="Path 9445" d="M2.9,3H19.1a.846.846,0,0,1,.9.778V16.222a.846.846,0,0,1-.9.778H2.9a.846.846,0,0,1-.9-.778V3.778A.846.846,0,0,1,2.9,3ZM18.2,6.3l-7.135,5.522L3.8,6.279v9.165H18.2ZM4.26,4.556l6.8,5.182,6.7-5.182Z" transform="translate(-2 -1.8)"/>
</svg>
                                    </span>
                                    Email Templates
                                </router-link>
                            </li>
                        <li class="nav-item">
                            <router-link class="nav-link" :to="{name: 'send_notification'}">
                                <span data-feather="file">
                                    <svg id="Send_Notification" data-name="Send Notification" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
  <path id="Path_9446" data-name="Path 9446" d="M0,0H18V18H0Z" fill="none"/>
  <path id="Path_9447" data-name="Path 9447" d="M15.5,13.25H17v1.5H2v-1.5H3.5V8a6,6,0,0,1,12,0Zm-1.5,0V8A4.5,4.5,0,0,0,5,8v5.25Zm-6.75,3h4.5v1.5H7.25Z" transform="translate(-0.5 -0.5)"/>
</svg>
                                </span>
                                Send Notification
                            </router-link>
                        </li>                        
                        <li class="nav-item">
                            <router-link class="nav-link " :to="{name: 'audit_log_viewer'}">
                                <span data-feather="users">
                                    <svg id="Audit_Log_Viewer" data-name="Audit Log Viewer" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
  <path id="Path_9448" data-name="Path 9448" d="M0,0H18V18H0Z" fill="none"/>
  <path id="Path_9449" data-name="Path 9449" d="M9.3,3A8.253,8.253,0,0,1,17.41,9.75a8.252,8.252,0,0,1-16.229,0A8.253,8.253,0,0,1,9.3,3Zm0,12a6.753,6.753,0,0,0,6.582-5.249,6.754,6.754,0,0,0-13.165,0A6.754,6.754,0,0,0,9.3,15Zm0-1.875A3.375,3.375,0,1,1,12.67,9.75,3.375,3.375,0,0,1,9.3,13.125Zm0-1.5A1.875,1.875,0,1,0,7.42,9.75,1.875,1.875,0,0,0,9.3,11.625Z" transform="translate(-0.295 -0.75)"/>
</svg>
                                </span>
                                Audit Log Viewer
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link active" :to="{name: 'sso_configuration'}">
                                <span data-feather="bar-chart-2">
                                    <svg id="SSoConfiguration" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
  <path id="Path_9450" data-name="Path 9450" d="M0,0H18V18H0Z"/>
  <path id="Path_9451" data-name="Path 9451" d="M3.1,13.25a7.514,7.514,0,0,1-.733-1.744,2.25,2.25,0,0,0,0-4.01A7.492,7.492,0,0,1,4.239,4.242,2.25,2.25,0,0,0,7.713,2.237a7.492,7.492,0,0,1,3.755,0,2.25,2.25,0,0,0,3.474,2,7.558,7.558,0,0,1,1.877,3.252,2.25,2.25,0,0,0,0,4.01,7.492,7.492,0,0,1-1.876,3.253,2.25,2.25,0,0,0-3.473,2.006,7.493,7.493,0,0,1-3.755,0,2.25,2.25,0,0,0-3.474-2A7.513,7.513,0,0,1,3.1,13.25Zm4.245.147a3.745,3.745,0,0,1,1.688,2.078,5.989,5.989,0,0,0,1.124,0,3.753,3.753,0,0,1,4.332-2.5A5.95,5.95,0,0,0,15.045,12a3.752,3.752,0,0,1,0-5,6.094,6.094,0,0,0-.562-.974,3.749,3.749,0,0,1-4.33-2.5,5.989,5.989,0,0,0-1.124,0A3.753,3.753,0,0,1,4.7,6.026,5.992,5.992,0,0,0,4.136,7a3.752,3.752,0,0,1,0,5,6.094,6.094,0,0,0,.562.974A3.745,3.745,0,0,1,7.341,13.4ZM9.59,11.75A2.25,2.25,0,1,1,11.84,9.5,2.25,2.25,0,0,1,9.59,11.75Zm0-1.5a.75.75,0,1,0-.75-.75A.75.75,0,0,0,9.59,10.25Z" transform="translate(-0.591 -0.5)"/>
</svg>
                                </span>
                                SSO Configuration
                            </router-link>
                        </li> -->
                        <!-- <li class="nav-item">
                            <a class="nav-link" href="#">
                                <span data-feather="layers">
                                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 13108" width="23"
                                        height="23" viewBox="0 0 23 23">
                                        <path data-name="Path 9424" d="M0 0h23v23H0z" style="fill:none" />
                                        <path data-name="Path 9425"
                                            d="M13.737 3.8H4.789v14.4h12.527V7.4h-3.579zM3 2.893A.893.893 0 0 1 3.894 2h10.738l4.474 4.5v12.594a.9.9 0 0 1-.888.906H3.888A.9.9 0 0 1 3 19.107zM12.421 13.2a3.567 3.567 0 0 1-4.637-.9 3.618 3.618 0 0 1 .289-4.742 3.563 3.563 0 0 1 4.722-.3 3.614 3.614 0 0 1 .891 4.674l1.977 1.989-1.263 1.27-1.979-1.991zm-.553-1.829a1.807 1.807 0 0 0 0-2.545 1.782 1.782 0 0 0-2.531 0 1.807 1.807 0 0 0 0 2.545 1.782 1.782 0 0 0 2.531 0z" />
                                    </svg>
                                </span>
                                Evaluator
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                <span data-feather="layers" class="help-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
                                        <path style="fill:none; stroke:none" d="M0 0h23v23H0z" />
                                        <circle cx="8.625" cy="8.625" r="8.625" transform="translate(2.875 2.875)"
                                            style="stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;fill:none" />
                                        <circle data-name="Oval" cx="3.594" cy="3.594" r="3.594"
                                            transform="translate(7.906 7.906)"
                                            style="stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;fill:none" />
                                        <path transform="translate(5.4 5.4)"
                                            style="stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;fill:none"
                                            d="M3.558 3.558 0 0" />
                                        <path data-name="Path" transform="translate(14.043 5.4)"
                                            style="stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;fill:none"
                                            d="M0 3.558 3.558 0" />
                                        <path data-name="Path" transform="translate(14.043 14.043)"
                                            style="stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;fill:none"
                                            d="m0 0 3.558 3.558" />
                                        <path data-name="Path" transform="translate(5.4 14.043)"
                                            style="stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;fill:none"
                                            d="M3.558 0 0 3.558" />
                                    </svg>
                                </span>
                                Help Centre
                            </a>
                        </li> -->
                    <!-- </ul>
                </div>
                </nav> -->
				<main >
					<div class="main_content align-items-center">
						<div class="row justify-content-between mb_40">
							<div class="col-md-8">
								<div class="heading">
									<h2>SSO using SAML 2.0</h2>
									<h3>PBE Management Dashboard</h3> </div>
							</div>
						</div>
						<div class="tabs sso_tab bg-white">
							<ul class="nav nav-tabs" id="myTab" role="tablist">
								<li class="nav-item" role="presentation">
									<button class="nav-link active" id="metadata-tab" data-bs-toggle="tab" data-bs-target="#metadata" type="button" role="tab" aria-controls="metadata" aria-selected="true">Metadata</button>
								</li>
								<li class="nav-item" role="presentation">
									<button class="nav-link" id="setup-tab" data-bs-toggle="tab" data-bs-target="#setup" type="button" role="tab" aria-controls="setup" aria-selected="false">Setup</button>
								</li>
								<li class="nav-item" role="presentation">
									<button class="nav-link" id="domain-mapping-tab" data-bs-toggle="tab" data-bs-target="#domain-mapping" type="button" role="tab" aria-controls="domain-mapping" aria-selected="false">Domain Mapping</button>
								</li>
								<li class="nav-item" role="presentation">
									<button class="nav-link" id="attribute-tab" data-bs-toggle="tab" data-bs-target="#attribute" type="button" role="tab" aria-controls="attribute" aria-selected="false">Attribute Mapping </button>
								</li>
								<li class="nav-item" role="presentation">
									<button class="nav-link" id="redirection-tab" data-bs-toggle="tab" data-bs-target="#redirection" type="button" role="tab" aria-controls="redirection" aria-selected="false">Redirection and SSO Link Settings</button>
								</li>
								<li class="nav-item" role="presentation">
									<button class="nav-link" id="custom-certificate-tab" data-bs-toggle="tab" data-bs-target="#custom-certificate" type="button" role="tab" aria-controls="custom-certificate" aria-selected="false">Custom Certificate</button>
								</li>
								<li class="nav-item" role="presentation">
									<button class="nav-link" id="custom-message-tab" data-bs-toggle="tab" data-bs-target="#custom-message" type="button" role="tab" aria-controls="custom-message" aria-selected="false">Custom Message</button>
								</li>
								<li class="nav-item" role="presentation">
									<button class="nav-link" id="account-info-tab" data-bs-toggle="tab" data-bs-target="#account-info" type="button" role="tab" aria-controls="account-info" aria-selected="false">Account Info</button>
								</li>
							</ul>
						</div>
						<div class="card ">
							<!-- Tabs Satrt Here -->
							<div class="tab-content " id="myTabContent">
								<div class="tab-pane fade show active" id="metadata" role="tabpanel" aria-labelledby="metadata-tab">
									<div class="form_progress d-flex justify-content-between col-md-6 mx-auto mt_40">
										<div class="progress d-flex justify-content-center flex-column">
											<div class="circle active"> 1 </div>
											<p class="mt_16 mb_0">Configure your Identity Provider</p>
										</div>
										<div class="progress d-flex justify-content-center flex-column">
											<div class="circle"> 2 </div>
											<p class="mt_16 mb_0">Configure Service Provider</p>
										</div>
									</div>
									<div class="identity_provider ">
										<h4 class="font_size_20 mt_40 mx-auto text-center">Configure your Identity Provider</h4>
										<div class="row mt_60">
											<div class="col-xl-6">
												<label for="disabledTextInput" class="form-label">Provide this metadata URL to your Identity Provider</label>
												<div class="position-relative">
													<input type="text" id="disabledTextInput" class="form-control" placeholder="/airbnb/?option=mosaml_metadata" disabled> <a href="#" class=" btn btn_primary copy">copy</a> </div>
											</div>
											<div class="col-xl-6">
												<label for="disabledTextInput" class="form-label">Download the Plugin XML metadata and upload it on your Identity Provider</label> <a href="#" class=" btn btn_primary mt_6">Download XML Metadata</a> </div>
										</div>
										<div class="row mt_60">
											<div class="col-md-12">
												<p class="m-0 font_bold font_size_16">Provide the following information to your Identity Provider.</p>
												<div class="table-responsive mt_20 sso_config_table">
													<table class="table">
														<tbody>
															<tr>
																<td>SP-EntityID / Issuer</td>
																<td>/airbnb/wp-content/plugins/miniorange-saml-20-single-sign-on/.</td>
																<td>
																	<a href="#" class="">
																		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 28.5 33">
																			<path id="Icon_material-content-copy" data-name="Icon material-content-copy" d="M24,1.5H6a3.009,3.009,0,0,0-3,3v21H6V4.5H24Zm4.5,6H12a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3H28.5a3.009,3.009,0,0,0,3-3v-21A3.009,3.009,0,0,0,28.5,7.5Zm0,24H12v-21H28.5Z" transform="translate(-3 -1.5)" fill="#4b4b4b" /> </svg>
																	</a>
																</td>
															</tr>
															<tr>
																<td>ACS (AssertionConsumerService) URL</td>
																<td>/airbnb/</td>
																<td>
																	<a href="#" class="">
																		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 28.5 33">
																			<path id="Icon_material-content-copy" data-name="Icon material-content-copy" d="M24,1.5H6a3.009,3.009,0,0,0-3,3v21H6V4.5H24Zm4.5,6H12a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3H28.5a3.009,3.009,0,0,0,3-3v-21A3.009,3.009,0,0,0,28.5,7.5Zm0,24H12v-21H28.5Z" transform="translate(-3 -1.5)" fill="#4b4b4b" /> </svg>
																	</a>
																</td>
															</tr>
															<tr>
																<td>Single Logout URL</td>
																<td>/airbnb/</td>
																<td>
																	<a href="#" class="">
																		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 28.5 33">
																			<path id="Icon_material-content-copy" data-name="Icon material-content-copy" d="M24,1.5H6a3.009,3.009,0,0,0-3,3v21H6V4.5H24Zm4.5,6H12a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3H28.5a3.009,3.009,0,0,0,3-3v-21A3.009,3.009,0,0,0,28.5,7.5Zm0,24H12v-21H28.5Z" transform="translate(-3 -1.5)" fill="#4b4b4b" /> </svg>
																	</a>
																</td>
															</tr>
															<tr>
																<td>Audience URI</td>
																<td>/airbnb/wp-content/plugins/miniorange-saml-20-single-sign-on/</td>
																<td>
																	<a href="#" class="">
																		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 28.5 33">
																			<path id="Icon_material-content-copy" data-name="Icon material-content-copy" d="M24,1.5H6a3.009,3.009,0,0,0-3,3v21H6V4.5H24Zm4.5,6H12a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3H28.5a3.009,3.009,0,0,0,3-3v-21A3.009,3.009,0,0,0,28.5,7.5Zm0,24H12v-21H28.5Z" transform="translate(-3 -1.5)" fill="#4b4b4b" /> </svg>
																	</a>
																</td>
															</tr>
															<tr>
																<td>NameID format</td>
																<td>urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress</td>
																<td>
																	<a href="#" class="">
																		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 28.5 33">
																			<path id="Icon_material-content-copy" data-name="Icon material-content-copy" d="M24,1.5H6a3.009,3.009,0,0,0-3,3v21H6V4.5H24Zm4.5,6H12a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3H28.5a3.009,3.009,0,0,0,3-3v-21A3.009,3.009,0,0,0,28.5,7.5Zm0,24H12v-21H28.5Z" transform="translate(-3 -1.5)" fill="#4b4b4b" /> </svg>
																	</a>
																</td>
															</tr>
															<tr>
																<td>Recipient URL</td>
																<td>/airbnb/</td>
																<td>
																	<a href="#" class="">
																		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 28.5 33">
																			<path id="Icon_material-content-copy" data-name="Icon material-content-copy" d="M24,1.5H6a3.009,3.009,0,0,0-3,3v21H6V4.5H24Zm4.5,6H12a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3H28.5a3.009,3.009,0,0,0,3-3v-21A3.009,3.009,0,0,0,28.5,7.5Zm0,24H12v-21H28.5Z" transform="translate(-3 -1.5)" fill="#4b4b4b" /> </svg>
																	</a>
																</td>
															</tr>
															<tr>
																<td>Destination URL</td>
																<td>/airbnb/</td>
																<td>
																	<a href="#" class="">
																		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 28.5 33">
																			<path id="Icon_material-content-copy" data-name="Icon material-content-copy" d="M24,1.5H6a3.009,3.009,0,0,0-3,3v21H6V4.5H24Zm4.5,6H12a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3H28.5a3.009,3.009,0,0,0,3-3v-21A3.009,3.009,0,0,0,28.5,7.5Zm0,24H12v-21H28.5Z" transform="translate(-3 -1.5)" fill="#4b4b4b" /> </svg>
																	</a>
																</td>
															</tr>
															<tr>
																<td>Default Relay State (Optional)</td>
																<td>/airbnb/</td>
																<td>
																	<a href="#" class="">
																		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="28" viewBox="0 0 28.5 33">
																			<path id="Icon_material-content-copy" data-name="Icon material-content-copy" d="M24,1.5H6a3.009,3.009,0,0,0-3,3v21H6V4.5H24Zm4.5,6H12a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3H28.5a3.009,3.009,0,0,0,3-3v-21A3.009,3.009,0,0,0,28.5,7.5Zm0,24H12v-21H28.5Z" transform="translate(-3 -1.5)" fill="#4b4b4b" /> </svg>
																	</a>
																</td>
															</tr>
															<tr>
																<td>Certificate (Optional) </td>
																<td><a href="#" class="btn btn_outline">Download</a></td>
																<td></td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
									<div class="service_provider d-none">
										<div class="col-md-8 mx-auto">
											<h4 class="font_size_20 mt_40 mx-auto text-center">Configure Service Provider</h4>
											<p class="mt_20">Assuming you are done with step 1 and you already have your Identity Provider's metadata, you can now proceed with configuring the Service Provider in either of the following two ways. </p>
											<div class="d-flex w-100 justify-content-center align-items-center mt_40"> <a href="#" class="btn btn_primary">Upload IDP Metadata</a>
												<p class="mx_20 mb_0 font_bold">OR</p> <a href="#" class="btn btn_primary">Manually configure SP</a> </div>
										</div>
									</div>
									<div class="w-100 d-flex mt_40 "> <a href="#" class="btn btn_primary ms-auto">Next  
                                  <span class="ml_10"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16.121 29.243">
  <path id="Path_146" data-name="Path 146" d="M9,5,21.5,17.5,9,30" transform="translate(-6.879 -2.879)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
</svg>
                            </span>
                            </a> </div>
									<div class="border-top mt_40">
										<h4 class="font_size_20 mt_40 mx-auto text-left">Service Provider Endpoints:</h4>
										<div class="row mt_40">
											<div class="col-md-6">
												<label for="disabledTextInput" class="form-label">SP Base URL:</label>
												<div class="position-relative">
													<input type="text" id="disabledTextInput" class="form-control" placeholder="https://www.pbergo.com/app" value="https://www.pbergo.com/app"> </div>
											</div>
											<div class="col-md-6">
												<label for="disabledTextInput" class="form-label">SP EntityID / Issuer:</label>
												<div class="position-relative">
													<input type="text" id="disabledTextInput" class="form-control" placeholder="/airbnb/wp-content/plugins/miniorange-saml-20-single-sign-on/" value="/airbnb/wp-content/plugins/miniorange-saml-20-single-sign-on/">
													<p class="mb_0 mt_14 font_size_12">Note: If you have already shared the above URLs or Metadata with your IdP, do NOT change SP EntityID. It might break your existing login flow.</p>
												</div>
											</div>
										</div>
										<div class="w-100 d-flex"> <a href="#" class="btn btn_primary ms-auto">Update  </a> </div>
									</div>
								</div>
								<div class="tab-pane fade" id="setup" role="tabpanel" aria-labelledby="setup-tab">
									<div class="table_card p-0 table-responsive m-0">
										<div class="table_heading">
											<div>
												<h4>List of IDPs</h4> </div>
											<div class="table_search ml_10">
												<div class="d-flex align-items-center">
													<div class="flex-shrink-0">
														<form action="">
															<input type="text" placeholder="Search" class="form-control mr_10"> <img src="../../assets/admin/images/search.svg" alt="img"> </form>
													</div>
													<div class="flex-grow-1"> <a href="#" class="btn btn_primary">Upload Multiple IDPs</a> </div>
												</div>
											</div>
										</div>
										<table class="table">
											<thead>
												<tr>
													<th scope="col">IDP Name</th>
													<th scope="col">IDP Entity ID</th>
													<th scope="col">Enable IDP
														<br><a href="#" class="font_size_12 text_primary">Enable all</a> | <a href="#" class="font_size_12 text_primary">Disable all</a></th>
													<th scope="col">Actions</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>AirBnB</td>
													<td>https://app.onelogin.com/saml/metadata/afdfb22a-3cf7-4852-85a8-1cc4a939e851 </td>
													<td class="checkbox-column">
														<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
													</td>
													<td>
														<div class="dropdown">
															<button class="btn btn_outline dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Select an Action </button>
															<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
																<li><a class="dropdown-item" href="#">Edit Configuration</a></li>
																<li><a class="dropdown-item" href="#">Test Configuration</a></li>
																<li><a class="dropdown-item" href="#">Custom Widget Button</a></li>
																<li><a class="dropdown-item" href="#">Delete IDP</a></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td>Pinterest</td>
													<td>http://www.okta.com/exk2ubfosof1jjurd2p7 </td>
													<td class="checkbox-column">
														<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
													</td>
													<td>
														<div class="dropdown">
															<button class="btn btn_outline dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Select an Action </button>
															<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
																<li><a class="dropdown-item" href="#">Edit Configuration</a></li>
																<li><a class="dropdown-item" href="#">Test Configuration</a></li>
																<li><a class="dropdown-item" href="#">Custom Widget Button</a></li>
																<li><a class="dropdown-item" href="#">Delete IDP</a></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td>Github</td>
													<td>http://www.okta.com/exk1f9yoa41ePDmqf1d8</td>
													<td class="checkbox-column">
														<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
													</td>
													<td>
														<div class="dropdown">
															<button class="btn btn_outline dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Select an Action </button>
															<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
																<li><a class="dropdown-item" href="#">Edit Configuration</a></li>
																<li><a class="dropdown-item" href="#">Test Configuration</a></li>
																<li><a class="dropdown-item" href="#">Custom Widget Button</a></li>
																<li><a class="dropdown-item" href="#">Delete IDP</a></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td>Netflix</td>
													<td>https://meechum.netflix.com</td>
													<td class="checkbox-column">
														<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
													</td>
													<td>
														<div class="dropdown">
															<button class="btn btn_outline dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Select an Action </button>
															<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
																<li><a class="dropdown-item" href="#">Edit Configuration</a></li>
																<li><a class="dropdown-item" href="#">Test Configuration</a></li>
																<li><a class="dropdown-item" href="#">Custom Widget Button</a></li>
																<li><a class="dropdown-item" href="#">Delete IDP</a></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td>Twilio</td>
													<td>http://www.okta.com/exk1gookwjkSWpDK61d8 </td>
													<td class="checkbox-column">
														<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
													</td>
													<td>
														<div class="dropdown">
															<button class="btn btn_outline dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Select an Action </button>
															<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
																<li><a class="dropdown-item" href="#">Edit Configuration</a></li>
																<li><a class="dropdown-item" href="#">Test Configuration</a></li>
																<li><a class="dropdown-item" href="#">Custom Widget Button</a></li>
																<li><a class="dropdown-item" href="#">Delete IDP</a></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td>NetflixAnimation </td>
													<td>netflix-pbergo-animation </td>
													<td class="checkbox-column">
														<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
													</td>
													<td>
														<div class="dropdown">
															<button class="btn btn_outline dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Select an Action </button>
															<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
																<li><a class="dropdown-item" href="#">Edit Configuration</a></li>
																<li><a class="dropdown-item" href="#">Test Configuration</a></li>
																<li><a class="dropdown-item" href="#">Custom Widget Button</a></li>
																<li><a class="dropdown-item" href="#">Delete IDP</a></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td>NetflixFTEs</td>
													<td>netflix-pbergo-employee</td>
													<td class="checkbox-column">
														<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
													</td>
													<td>
														<div class="dropdown">
															<button class="btn btn_outline dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Select an Action </button>
															<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
																<li><a class="dropdown-item" href="#">Edit Configuration</a></li>
																<li><a class="dropdown-item" href="#">Test Configuration</a></li>
																<li><a class="dropdown-item" href="#">Custom Widget Button</a></li>
																<li><a class="dropdown-item" href="#">Delete IDP</a></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td>Ok9</td>
													<td>http://www.okta.com/exk1hpqzjhyIDuJac1d8</td>
													<td class="checkbox-column">
														<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
													</td>
													<td>
														<div class="dropdown">
															<button class="btn btn_outline dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Select an Action </button>
															<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
																<li><a class="dropdown-item" href="#">Edit Configuration</a></li>
																<li><a class="dropdown-item" href="#">Test Configuration</a></li>
																<li><a class="dropdown-item" href="#">Custom Widget Button</a></li>
																<li><a class="dropdown-item" href="#">Delete IDP</a></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td>CZI</td>
													<td>http://www.okta.com/exkg0qxyecHxcDjC81t7</td>
													<td class="checkbox-column">
														<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
													</td>
													<td>
														<div class="dropdown">
															<button class="btn btn_outline dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Select an Action </button>
															<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
																<li><a class="dropdown-item" href="#">Edit Configuration</a></li>
																<li><a class="dropdown-item" href="#">Test Configuration</a></li>
																<li><a class="dropdown-item" href="#">Custom Widget Button</a></li>
																<li><a class="dropdown-item" href="#">Delete IDP</a></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td>Atlassian</td>
													<td>https://aas0641.my.idaptive.app/a1a3347c-340a-47ed-becd-80f4cdbe3de9</td>
													<td class="checkbox-column">
														<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
													</td>
													<td>
														<div class="dropdown">
															<button class="btn btn_outline dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Select an Action </button>
															<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
																<li><a class="dropdown-item" href="#">Edit Configuration</a></li>
																<li><a class="dropdown-item" href="#">Test Configuration</a></li>
																<li><a class="dropdown-item" href="#">Custom Widget Button</a></li>
																<li><a class="dropdown-item" href="#">Delete IDP</a></li>
															</ul>
														</div>
													</td>
												</tr>
												<tr>
													<td>Twitch_t72</td>
													<td> urn:saml2:twitch_prod</td>
													<td class="checkbox-column">
														<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
													</td>
													<td>
														<div class="dropdown">
															<button class="btn btn_outline dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"> Select an Action </button>
															<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
																<li><a class="dropdown-item" href="#">Edit Configuration</a></li>
																<li><a class="dropdown-item" href="#">Test Configuration</a></li>
																<li><a class="dropdown-item" href="#">Custom Widget Button</a></li>
																<li><a class="dropdown-item" href="#">Delete IDP</a></li>
															</ul>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
										<div class="w-100 d-flex mt_40 mb_40"> <a href="#" class="btn btn_outline ms-auto mr_16">Add New IDP  </a> <a href="#" class="btn btn_outline mr_16">Export Configuration  </a> <a href="#" class="btn btn_primary ">Save  </a> </div>
									</div>
								</div>
								<div class="tab-pane fade" id="domain-mapping" role="tabpanel" aria-labelledby="domain-mapping-tab">
									<h4 class="font_size_20 mt_40 mx-auto text-left">Domain Mapping</h4>
									<h4 class="font_size_18 mt_40 mx-auto text-left">Enable SSO Login based on Domain Mapping <a href="#" class="text_primary hover_black">What does this mean?</a> 
									<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input mt_2 ml_16"></h4>
									<div class="row mt_40">
										<div class="custom_radio_main_box">
											<h4 class="font_size_18 mx-auto text-left">If Domain Mapping fails (Choose One):</h4>
											<div class="form-check">
												<input type="radio" name="flexRadioDefault" id="flexRadioDefault2" class="form-check-input">
												<label for="flexRadioDefault2" class="form-check-label">Allow User to login via WP credentials.</label>
											</div>
											<div class="form-check">
												<input type="radio" name="flexRadioDefault" id="flexRadioDefault2" class="form-check-input">
												<label for="flexRadioDefault2" class="form-check-label">Redirect to Default Identity Provider.</label>
											</div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">AirBnB</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Pinterest :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Github :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Netflix :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Twilio :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">NetflixAnimation :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">NetflixFTEs :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Ok9 :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">CZI :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Atlassian :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Twitch_t72 :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">PureStorage :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Colgate :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">SCVWD-SC38 :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">nrel :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Instacart :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Nutanix :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="nutanix.com" value="nutanix.com"> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Amazon_2 :</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semi-colon separted domains. Eg. miniorange.com" value=""> </div>
										</div>
									</div>
									<div class="w-100 d-flex mt_40"> <a href="#" class="btn btn_primary ">Save  </a> </div>
								</div>
								<div class="tab-pane fade" id="attribute" role="tabpanel" aria-labelledby="attribute-tab">
									<h4 class="font_size_20 mx-auto text-left">Attribute Mapping (Optional)</h4>
									<div class="click-text mt_10 mb_10 font_size_12">[ <a href="#" class="text_primary hover_black">Click here</a> to know more. ]</div>
									<p class="mb_0 mt_14 font_size_12">NOTE: Use attribute name <span>NameID</span> if Identity is in the NameIdentifier element of the subject statement in SAML Response.</p>
									<div class="row mt_40">
										<div class="col-md-8">
											<label for="disabledTextInput" class="form-label">Select your IdP:</label>
											<div class="position-relative input-group">
												<select class="form-select" aria-label="Default select example">
													<option selected>Colgate</option>
													<option value="1">Colgate</option>
													<option value="2">Colgate</option>
													<option value="3">Colgate</option>
												</select>
												<input type="button" value="Select" class="button btn btn_primary ml_5" onclick=""> 
												<a href="#" class="btn btn_primary reset_btn">Reset Role Mapping for Colgate</a>
												</div>
										</div>
										<div class="col-md-4">
											<!-- <div class="w-100 d-flex mt_34"> <a href="#" class="btn btn_primary ">Reset Role Mapping for Colgate</a> </div> -->
										</div>
										<p class="mb_0 mt_14 font_size_12"> NOTE: Default Attribute Mapping will be assigned to all the IDPs. If you want to provide IDP specific mapping, please choose the specific IDP from the list.</p>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Username:</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="NameID" value="NameID"> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Email:</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="NameID" value="NameID"> </div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Last Name:</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter attribute name for First Name" value=""> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Last Name:</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter attribute name for Last Name" value=""> </div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Group/Role:</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter attribute name for Group/Role" value=""> </div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Display Name:</label>
											<div class="position-relative">
												<select class="form-select" aria-label="Default select example">
													<option selected>Username</option>
													<option value="1">Firstname</option>
													<option value="2">Lastname</option>
													<option value="3">Lastname</option>
												</select>
											</div>
										</div>
									</div>
									<div class="map-attr">
										<h4 class="font_size_20 mx-auto text-left mt_40">Map Custom Attributes</h4>
										<p>Map extra IDP attributes which you wish to be included in the user profile below</p>
										<p>NOTE: Customized Attribute Mapping means you can map any attribute of the IDP to the attributes of user-meta table of your database.</p>
										<p>Enable the Display Attribute option for an attribute if you want to display it in the Wordpress <a href="#" class="text_primary">Users</a> menu.</p>
										<div class="w-100 d-flex mt_40"> <a href="#" class="btn btn_primary hover_black">Add Attribute</a> </div>
									</div>
									<div class="row mt_40">
										<div class="col-md-3">
											<label for="disabledTextInput" class="form-label">Attribute Name:</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Custom attribute name" value=""> </div>
										</div>
										<div class="col-md-7">
											<label for="disabledTextInput" class="form-label">Attribute Value:</label>
											<div class="position-relative">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter attribute name from IDP" value=""> </div>
										</div>
										<div class="col-md-2">
											<label for="disabledTextInput" class="form-label">Display Attribute:</label>
											<div class="position-relative display-attr-switch">
												<label class="switch ml_16">
													<input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input mt_0"></label>
											</div>
										</div>
										<div class="w-100 d-flex mt_40"> <a href="#" class="btn btn_primary ">Save</a> </div>
									</div>
									<div class="border-top mt_40">
										<h4 class="font_size_40 mx-auto mt_40 text-left">Domain Restriction (Optional)</h4>
										<div class="click-text mt_10 mb_10 font_size_12">[ <a href="#" class="text_primary">Click here</a> to know how this is useful. ]</div>
										<p class="mb_0 mt_14 font_size_12">Note: You can enter the semicolon separated list of domains like domain1.com;domain2.com;domain3.com</p>
										<h4 class="font_size_16 mt_40 mx-auto text-left switch-left">
											<label class="switch"><input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input"></label> Enable domain restriction login.</h4>
										<div class="row mt_40">
											<div class="col-md-6">
												<div class="form-check">
													<input type="radio" name="flexRadioDefault" id="flexRadioDefault2" class="form-check-input">
													<label for="flexRadioDefault2" class="form-check-label">Allow users to login with specified domains</label>
												</div>
												<div class="form-check">
													<input type="radio" name="flexRadioDefault" id="flexRadioDefault2" class="form-check-input">
													<label for="flexRadioDefault2" class="form-check-label">Deny users to login with specified domains</label>
												</div>
											</div>
											<div class="col-md-6">
												<div class="position-relative">
													<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter semicolon(;) separated domains to be allowed or restrict" value=""> </div>
												<div class="w-100 d-flex mt_20"> <a href="#" class="btn btn_primary ">Save</a> </div>
											</div>
										</div>
									</div>
									<div class="border-top mt_40">
										<h4 class="font_size_40 mx-auto mt_40 text-left">Role Mapping (Optional)</h4>
										<div class="click-text mt_10 mb_10">[ <a href="#" class="text_primary hover_black">Click here</a> to know more. ]</div>
										<div class="row mt_40">
											<div class="col-md-12">
												<label for="disabledTextInput" class="form-label">Select your IdP :</label>
												<div class="position-relative input-group">
													<select class="form-select" aria-label="Default select example">
														<option selected="">Default Domain Restriction</option>
														<option value="1">AirBnB</option>
														<option value="2">Pinterest</option>
														<option value="3">Github</option>
													</select>
													<input type="button" value="Select" class="button btn btn_primary ml_5" onclick=""> </div>
											</div>
											<p class="mb_0 mt_14 font_size_12"> NOTE: Default Attribute Mapping will be assigned to all the IDPs. If you want to provide IDP specific mapping, please choose the specific IDP from the list.</p>
										</div>
										<div class="row mt_40">
											<div class="col-md-8">
												<label for="disabledTextInput" class="form-label">Select your IdP :</label>
												<div class="position-relative input-group">
													<select class="form-select" aria-label="Default select example">
														<option selected>AirBnB</option>
														<option value="1">AirBnB</option>
														<option value="2">AirBnB</option>
														<option value="3">AirBnB</option>
													</select>
													<input type="button" value="Select" class="button btn btn_primary ml_5" onclick=""> 
													<a href="#" class="btn btn_primary reset_btn">Reset Role Mapping for AirBnB</a></div>
											</div>
											<div class="col-md-4">
												<!-- <div class="w-100 d-flex mt_36"> <a href="#" class="btn btn_primary ">Reset Role Mapping for AirBnB</a> </div> -->
											</div>
											<p class="mb_20 mt_14 font_size_12">NOTE: Default Role Mapping will be assigned to all the IDPs. If you want to provide IDP specific mapping, please choose the specific IDP from the list.</p>
											<div class="switch-btns row mt_20">
												<div class="col-md-12">
													<h4 class="font_size_16 mt_40 mx-auto text-left switch-left"><label class="switch">
                              <input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
                            </label> Do not auto create users if roles are not mapped here</h4>
													<h4 class="font_size_16 mt_10 mx-auto text-left switch-left"><label class="switch">
                              <input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
                            </label> Do not assign role to unlisted users</h4>
													<h4 class="font_size_16 mt_10 mx-auto text-left switch-left"><label class="switch">
                              <input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
                            </label> Do not update existing user's roles</h4>
													<h4 class="font_size_16 mt_10 mx-auto text-left switch-left"><label class="switch">
                              <input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
                            </label>Do not allow the users to login with the following roles</h4>
													<div class="position-relative mt_20">
														<input type="text" id="disabledTextInput" class="form-control" placeholder="Semi-colon(;) separated Group/Role value" value=""> </div>
												</div>
											</div>
											<div class="row mt_40">
												<div class="col-md-6">
													<label for="disabledTextInput" class="form-label">Default Role :</label>
													<div class="position-relative">
														<select class="form-select" aria-label="Default select example">
															<option selected>Subscriber</option>
															<option value="1">Subscriber</option>
															<option value="2">Subscriber</option>
															<option value="3">Subscriber</option>
														</select>
														<p class="mb_0 mt_14 font_size_12">Select the default role to assign to Users.</p>
													</div>
												</div>
												<div class="col-md-6">
													<label for="disabledTextInput" class="form-label">Administrator :</label>
													<div class="position-relative">
														<input type="text" id="disabledTextInput" class="form-control" placeholder="Semi-colon(;) separated Group/Role value for Administrator" value=""> </div>
												</div>
											</div>
											<div class="row mt_40">
												<div class="col-md-6">
													<label for="disabledTextInput" class="form-label">Editor :</label>
													<div class="position-relative">
														<input type="text" id="disabledTextInput" class="form-control" placeholder="Semi-colon(;) separated Group/Role value for Editor" value=""> </div>
												</div>
												<div class="col-md-6">
													<label for="disabledTextInput" class="form-label">Author :</label>
													<div class="position-relative">
														<input type="text" id="disabledTextInput" class="form-control" placeholder="Semi-colon(;) separated Group/Role value for Author" value=""> </div>
												</div>
											</div>
											<div class="row mt_40">
												<div class="col-md-6">
													<label for="disabledTextInput" class="form-label">Contributor :</label>
													<div class="position-relative">
														<input type="text" id="disabledTextInput" class="form-control" placeholder="Semi-colon(;) separated Group/Role value for Contributor" value=""> </div>
												</div>
												<div class="col-md-6">
													<label for="disabledTextInput" class="form-label">Subscriber :</label>
													<div class="position-relative">
														<input type="text" id="disabledTextInput" class="form-control" placeholder="Semi-colon(;) separated Group/Role value for Subscriber" value=""> </div>
												</div>
												<div class="w-100 d-flex mt_40"> <a href="#" class="btn btn_primary ">Save</a> </div>
											</div>
										</div>
									</div>
								</div>
								<div class="tab-pane fade" id="redirection" role="tabpanel" aria-labelledby="redirection-tab">
									<h4 class="font_size_40 mx-auto text-left">SSO Login Options</h4>
									<div class="click-text mt_10 mb_10 font_size_12">[ <a href="#" class="text_primary hover_black">Click here</a> to know how this is useful. ]</div>
									<div class="row mt_40">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Relay State URL :</label>
											<div class="position-relative input-group">
												<input type="text" id="disabledTextInput" class="form-control" placeholder="Enter a valid URL (Example: https://www.pbergo.com/app)" value=""> </div>
										</div>
										<div class="col-md-6 mt_30"> <a href="#" class="btn btn_primary ">Update</a> </div>
										<p class="mb_0 mt_14 font_size_12"> Users will always be redirected to this URL after SSO.
											<br> When left blank, the users will be redirected to the same page from where the SSO was initiated. </p>
									</div>
									<div class="border-top mt_40">
										<h4 class="font_size_60 mx-auto text-left mt_40">Auto-Redirection from site</h4>
										<div class="redirection-bullets">
											<div class="form-check">
												<input type="radio" name="flexRadioDefault" id="flexRadioDefault2" class="form-check-input">
												<label for="flexRadioDefault2" class="form-check-label"> Do not use the Auto-redirect feature.</label>
											</div>
											<div class="form-check">
												<input type="radio" name="flexRadioDefault" id="flexRadioDefault2" class="form-check-input">
												<label for="flexRadioDefault2" class="form-check-label">Redirect to default IDP if user not logged in. <a href="#" class="text_primary hover_black">[What does this mean?]</a></label>
											</div>
											<div class="form-check">
												<input type="radio" name="flexRadioDefault" id="flexRadioDefault2" class="form-check-input">
												<label for="flexRadioDefault2" class="form-check-label">Redirect to Wordpress Login if user not logged in. <a href="#" class="text_primary hover_black">[What does this mean?]</a></label>
											</div>
											<div class="form-check">
												<input type="radio" name="flexRadioDefault" id="flexRadioDefault2" class="form-check-input">
												<label for="flexRadioDefault2" class="form-check-label"> Auto-redirect to the public page of the site. <a href="#" class="text_primary hover_black">[What does this mean?]</a></label>
											</div>
										</div>
										<div class="row mt_40">
											<div class="col-md-6">
												<label for="disabledTextInput" class="form-label">Public Page Url :</label>
												<div class="position-relative">
													<input type="text" id="disabledTextInput" class="form-control" placeholder="" value=""> </div>
												<p class="mb_0 mt_14 font_size_12"> If this URL is set, users will always be redirected to this URL (if you will select the Auto-redirect to the public page of the site option) if try to access any page before login.</p>
											</div>
											<div class="col-md-6">
												<div class="w-100 d-flex mt_34"> <a href="#" class="btn btn_primary ">Update</a> </div>
											</div>
										</div>
										<h5 class="font_size_16 mt_40 mb_20">Add the following shortcode to see the list of IDPs in the dropdown</h5>
										<div class="attrr-code mt_10">
											<label for="disabledTextInput" class="form-label">For PHP page :</label> <code>echo do_shortcode('[MO_SAML_IDP_LIST]');</code> </div>
										<div class="attrr-code mt_10">
											<label for="disabledTextInput" class="form-label">For HTML page :</label> <code>[MO_SAML_IDP_LIST]</code> </div>
										<div class="row mt_10">
											<div class="col-md-6">
												<label for="disabledTextInput" class="form-label">Shortcode Login text :</label>
												<div class="position-relative">
													<input type="text" id="disabledTextInput" class="form-control" placeholder="" value=""> </div>
											</div>
											<div class="col-md-6">
												<div class="w-100 d-flex mt_34"> <a href="#" class="btn btn_primary ">Update</a> </div>
											</div>
										</div>
										<div class="auth-content">
											<h4 class="font_size_16 mt_40 mx-auto text-left switch-left"><label class="switch">
                                <input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
                              </label>Force authentication with your IdP on each login attempt <a href="#" class="text_primary hover_black">[What does this mean?]</a></h4>
											<h4 class="font_size_16 mt_40 mx-auto text-left switch-left">
												<label class="switch">
                                <input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
                              </label>Redirect to Default IdP from WordPress Login Page</h4>
											<p class="mb_0 mt_14 font_size_12">Enable the above option if you want the users visiting any of the following URLs to get redirected to the Default IdP for authentication: <span>/airbnb/wp-login.php</span> or <span>/airbnb/wp-admin/</span></p>
											<div class="backdoor-login">
												<h4 class="font_size_16 mt_40 mx-auto text-left switch-left"><label class="switch">
                                  <input type="checkbox" value="" aria-label="..." id="flexCheckDefault" class="form-check-input">
                                </label>Enable Backdoor Login</h4>
												<p class="mb_0 mt_14 font_size_12">Enabling this option creates a backdoor to login to your Website using WordPress credentials incase you get locked out of your IdP.</p> <span>(
                                  <i>Note down this URL: </i>
                                  <code>/airbnb/wp-login.php?saml_sso= <div class="position-relative d-inline-block">
                                    <input type="text" id="disabledTextInput" class="form-control" placeholder="false" value="false">
                              </div></code>
                                )
                                </span>
												<div class="w-100 d-flex mt_20"> <a href="#" class="btn btn_primary ">Update</a> </div>
											</div>
											<div class="warning-text font_size_14 mt_40"> <span>WARNING:</span> Checking the above option will <b>enable a security hole</b>. Anybody knowing the above URL will be able to login to your website using WordPress Credentials. <b>Please do not share this URL.</b> </div>
										</div>
									</div>
									<div class="login-btn-area mt_40 border-top">
										<div class="row">
											<div class="col-md-6">
												<h4 class="font_size_60 mx-auto text-left mt_40">Login button</h4> </div>
											<div class="col-md-6">
												<div class="w-100 d-flex mt_30 justify-content-end"> <a href="#" class="btn btn_primary ">Reset Login Button Settings</a> </div>
											</div>
										</div>
										<div class="row mt_40">
											<div class="col-md-6">
												<label for="disabledTextInput" class="form-label">Select your IdP :</label>
												<div class="position-relative input-group">
													<select class="form-select" aria-label="Default select example">
														<option selected="">--Select your IdP--</option>
														<option value="1">AirBnB</option>
														<option value="2">Pinterest</option>
														<option value="3">Github</option>
													</select>
												</div>
												
											</div>
											<div class="col-md-6">
												<div class="w-100 d-flex mt_30"> <a href="#" class="btn btn_primary ">Select</a> </div>
											</div>
										</div>
									</div>
									<div class="sso-links border-top mt_40">
										<h4 class="font_size_60 mx-auto text-left mt_40">Use Widget and SSO Links</h4>
										<p>1. Add Widget :</p>
										<ol>
											<li class="font_size_12">Go to Appearances > <a href="#" class="text_primary hover_black">Widgets.</a></li>
											<li class="font_size_12">Select the miniOrange SAML Login widget. Drag and drop to your favourite location and save.</li>
											<li class="font_size_12">This will add the links of all IdPs you have configured and enabled.</li>
										</ol>
										<p>2. Add SSO Links: Use following links to add on your HTML Pages and add the redirect URL you want to redirect after the authentication.</p>
										<ol>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=AirBnB" &gt;Login with AirBnB&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=Pinterest" &gt;Login with Pinterest&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=Github" &gt;Login with Github&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=Netflix" &gt;Login with Netflix&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=Twilio" &gt;Login with Twilio&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=NetflixAnimation" &gt;Login with NetflixAnimation&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=NetflixFTEs" &gt;Login with NetflixFTEs&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=NetflixFTEs" &gt;Login with NetflixFTEs&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=Ok9" &gt;Login with Ok9&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=CZI" &gt;Login with CZI&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=Atlassian" &gt;Login with Atlassian&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=Twitch_t72" &gt;Login with Twitch_t72&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=PureStorage" &gt;Login with PureStorage&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=Colgate" &gt;Login with Colgate&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=SCVWD-SC38" &gt;Login with SCVWD-SC38&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=nrel" &gt;Login with nrel&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=Instacart" &gt;Login with Instacart&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=Nutanix" &gt;Login with Nutanix&lt;/a&gt;</li>
											<li class="font_size_12">&lt;a href="/airbnb/?option=saml_user_login&amp;idp=Amazon_2" &gt;Login with Amazon_2&lt;/a&gt;</li>
										</ol>
										<p class="mt_20">For example:- If you want to redirect to same page from where he initiated the login, then use the SSO Link as given below :</p>
										<ul>
											<li class="list-unstyled font_size_12"><i>/airbnb/?option=saml_user_login&amp;idp=&lt;idp-name&gt;&amp;redirect_to=<span>&lt;page_url&gt;</span></i></li>
											<li class="font_size_12">Replace the <span>&lt;page_url&gt;</span> with the address of the page.</li>
										</ul>
									</div>
								</div>
								<div class="tab-pane fade" id="custom-certificate" role="tabpanel" aria-labelledby="custom-certificate">
									<h4 class="font_size_40 mx-auto text-left">Add Custom Certificate</h4>
									<div class="click-text mt_10 mb_10 font_size_12">[ <a href="#" class="text_primary">Click here</a> to know how this is useful. ]</div>
									<div class="row mt_40 custom-certificate">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">X.509 Public Certificate <span>*</span> :</label>
											<div class="position-relative">
												<textarea rows="10" cols="5" width="100%" name="saml_public_x509_certificate" placeholder="Enter the X.509 public certificate here" required=""> -----BEGIN CERTIFICATE----- MIIF+zCCA+OgAwIBAgIUT7IV/fMAevBVZh3x1f858qBT0HQwDQYJKoZIhvcNAQEL BQAwgYwxCzAJBgNVBAYTAklOMQswCQYDVQQIDAJNSDENMAsGA1UEBwwEUFVORTET MBEGA1UECgwKTUlOSU9SQU5HRTETMBEGA1UECwwKTUlOSU9SQU5HRTETMBEGA1UE AwwKTUlOSU9SQU5HRTEiMCAGCSqGSIb3DQEJARYTaW5mb0BtaW5pb3JhbmdlLmNv bTAeFw0yMDA5MjgwNDU0MDFaFw0yMjA5MjgwNDU0MDFaMIGMMQswCQYDVQQGEwJJ TjELMAkGA1UECAwCTUgxDTALBgNVBAcMBFBVTkUxEzARBgNVBAoMCk1JTklPUkFO R0UxEzARBgNVBAsMCk1JTklPUkFOR0UxEzARBgNVBAMMCk1JTklPUkFOR0UxIjAg BgkqhkiG9w0BCQEWE2luZm9AbWluaW9yYW5nZS5jb20wggIiMA0GCSqGSIb3DQEB AQUAA4ICDwAwggIKAoICAQCwKCE4hKFSmPnTRXpqw1yuJFQVGNl1wpqhBF2NRiQQ hoUzHX2i14Oo9/5NZSiUb+gSZeCJSe3SykXasinTl64n+qylAerE6x4zErLsZVK4 rFdSzGpowwiW82FjKCOJa4/z6uxpPlVI2rSFdbS/KU9oZnEmlFRpSjGSdd6z+98R 4Gj6+Wbv9JP2W4PmIa9NtQ8tx/p47tpf2jo3qLqJYJ/Ag4Fot3zkCT/Eo0tH3bVZ rfNV48zGKGdxVCbLCXD3D+8kDxaxUznrMQeZqxSI/b/XPNAuXuu8orFuUoVfMTob Xt7t8y0L+a4+ur1xrQYgxOR29gECBfBhXMFubzj+K86+bOE+T/rRhImivewws4iT G3Uq3Xkc5oy2e1cE1QLx910S1uw7ZZWXsUXUPF08vd/vb4gZMUhtPhzUJYIkJKJT bmDaeLBgpYkeB6NqD8WGBbMvN6Ag/zdJpku+y9l+cIlfDWceR5yIGJ7E8QIOnwl1 a/zWFHHuUY+92WU9W2e2rAjONMcHibQb8m+zYs97nJEf3wqgbu89eRrkrY88UQid /L8cZgBTlTC0XyRIgWvSeDSw8CbcDVEU10jSNdyRD+vfOiMrrUOTZifFUYrJyLPI 6rF2KeZgCQ9icsvgekkW+jcLSxpSMMiDvHRBi6u0+Un7ST0nis9V062GRCq3S908 HQIDAQABo1MwUTAdBgNVHQ4EFgQUmLtHmwWsBN2o0Xuwdmqw7lH/n7MwHwYDVR0j BBgwFoAUmLtHmwWsBN2o0Xuwdmqw7lH/n7MwDwYDVR0TAQH/BAUwAwEB/zANBgkq hkiG9w0BAQsFAAOCAgEAq7vgFpNw+Q0RuPifR/KFo2JW9k428L1DEwXxvGyuZu50 WGvPr4RHJocz7T67alS3jxM/vMneBpkXZJs6n23GzBvXwD6J1TbcnEwNlpfGWQWL E1EGz71s5sIXNULcFqC2csWM554hMAMaQbI98bPEKtuuu2vYcdP5y436xn1Sfg6b vkXZC78t27UE5nqCgwX/WOhdfPYDbjIT2V3fOEPdhJAkIJpzoav/J/m5V3B6hKjq lYx8pj0UAgWn72kTWjSKZ67fdH3l9QvUwWmA6sJSV7rzUFGTQMj4nhS/tX8q9BQU I/6c1ZyHk/Nbrs7o4ocakjNW6x798DVkpMyF7EkWhxlyHqGrGF59f6GJm6nJ2j+W H4cBFagKtxFdj7qtJsLkjrC+JOuedguVlKjUXwAgpPTqNH7Hg9CmRus6ya0DFWIb cgWQvl4PVyTKPEQQyITp9OzK1/3zRLE9FA6E0OoitcOQ9zAYAqs3y9oN6Ft7KDVg +ef6oM90fmZvE+cnUxjWhyJFzyw+HLqETeV8RiI3+Ofhd2M7Soa3UntxHOuFQBIG FbYW91JY6q7Ms25XDjShLtoQskW2beVEJjivcYOgoOi13QgARhk0ziv9XwN9fQQy muG0SkRRx+ZTtFi+ezRHoPlJhcWVIybEeujQz22bN1DkvX8z+cL54ACugYk+13k= -----END CERTIFICATE----- </textarea>
											</div>
											<div class="note-description mt_20">
												<p class="mb_10">NOTE: <span class="font_size_12">Format of the certificate:</span></p>
												<div class="cert-formate">-----BEGIN CERTIFICATE-----
													<br> XXXXXXXXXXXXXXXXXXXXXXXXXXX
													<br> -----END CERTIFICATE----- </div>
											</div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">X.509 Private Certificate <span>*</span> :</label>
											<div class="position-relative">
												<textarea rows="10" cols="5" width="100%" name="saml_public_x509_certificate" placeholder="Enter the X.509 public certificate here" required=""> -----BEGIN CERTIFICATE----- MIIF+zCCA+OgAwIBAgIUT7IV/fMAevBVZh3x1f858qBT0HQwDQYJKoZIhvcNAQEL BQAwgYwxCzAJBgNVBAYTAklOMQswCQYDVQQIDAJNSDENMAsGA1UEBwwEUFVORTET MBEGA1UECgwKTUlOSU9SQU5HRTETMBEGA1UECwwKTUlOSU9SQU5HRTETMBEGA1UE AwwKTUlOSU9SQU5HRTEiMCAGCSqGSIb3DQEJARYTaW5mb0BtaW5pb3JhbmdlLmNv bTAeFw0yMDA5MjgwNDU0MDFaFw0yMjA5MjgwNDU0MDFaMIGMMQswCQYDVQQGEwJJ TjELMAkGA1UECAwCTUgxDTALBgNVBAcMBFBVTkUxEzARBgNVBAoMCk1JTklPUkFO R0UxEzARBgNVBAsMCk1JTklPUkFOR0UxEzARBgNVBAMMCk1JTklPUkFOR0UxIjAg BgkqhkiG9w0BCQEWE2luZm9AbWluaW9yYW5nZS5jb20wggIiMA0GCSqGSIb3DQEB AQUAA4ICDwAwggIKAoICAQCwKCE4hKFSmPnTRXpqw1yuJFQVGNl1wpqhBF2NRiQQ hoUzHX2i14Oo9/5NZSiUb+gSZeCJSe3SykXasinTl64n+qylAerE6x4zErLsZVK4 rFdSzGpowwiW82FjKCOJa4/z6uxpPlVI2rSFdbS/KU9oZnEmlFRpSjGSdd6z+98R 4Gj6+Wbv9JP2W4PmIa9NtQ8tx/p47tpf2jo3qLqJYJ/Ag4Fot3zkCT/Eo0tH3bVZ rfNV48zGKGdxVCbLCXD3D+8kDxaxUznrMQeZqxSI/b/XPNAuXuu8orFuUoVfMTob Xt7t8y0L+a4+ur1xrQYgxOR29gECBfBhXMFubzj+K86+bOE+T/rRhImivewws4iT G3Uq3Xkc5oy2e1cE1QLx910S1uw7ZZWXsUXUPF08vd/vb4gZMUhtPhzUJYIkJKJT bmDaeLBgpYkeB6NqD8WGBbMvN6Ag/zdJpku+y9l+cIlfDWceR5yIGJ7E8QIOnwl1 a/zWFHHuUY+92WU9W2e2rAjONMcHibQb8m+zYs97nJEf3wqgbu89eRrkrY88UQid /L8cZgBTlTC0XyRIgWvSeDSw8CbcDVEU10jSNdyRD+vfOiMrrUOTZifFUYrJyLPI 6rF2KeZgCQ9icsvgekkW+jcLSxpSMMiDvHRBi6u0+Un7ST0nis9V062GRCq3S908 HQIDAQABo1MwUTAdBgNVHQ4EFgQUmLtHmwWsBN2o0Xuwdmqw7lH/n7MwHwYDVR0j BBgwFoAUmLtHmwWsBN2o0Xuwdmqw7lH/n7MwDwYDVR0TAQH/BAUwAwEB/zANBgkq hkiG9w0BAQsFAAOCAgEAq7vgFpNw+Q0RuPifR/KFo2JW9k428L1DEwXxvGyuZu50 WGvPr4RHJocz7T67alS3jxM/vMneBpkXZJs6n23GzBvXwD6J1TbcnEwNlpfGWQWL E1EGz71s5sIXNULcFqC2csWM554hMAMaQbI98bPEKtuuu2vYcdP5y436xn1Sfg6b vkXZC78t27UE5nqCgwX/WOhdfPYDbjIT2V3fOEPdhJAkIJpzoav/J/m5V3B6hKjq lYx8pj0UAgWn72kTWjSKZ67fdH3l9QvUwWmA6sJSV7rzUFGTQMj4nhS/tX8q9BQU I/6c1ZyHk/Nbrs7o4ocakjNW6x798DVkpMyF7EkWhxlyHqGrGF59f6GJm6nJ2j+W H4cBFagKtxFdj7qtJsLkjrC+JOuedguVlKjUXwAgpPTqNH7Hg9CmRus6ya0DFWIb cgWQvl4PVyTKPEQQyITp9OzK1/3zRLE9FA6E0OoitcOQ9zAYAqs3y9oN6Ft7KDVg +ef6oM90fmZvE+cnUxjWhyJFzyw+HLqETeV8RiI3+Ofhd2M7Soa3UntxHOuFQBIG FbYW91JY6q7Ms25XDjShLtoQskW2beVEJjivcYOgoOi13QgARhk0ziv9XwN9fQQy muG0SkRRx+ZTtFi+ezRHoPlJhcWVIybEeujQz22bN1DkvX8z+cL54ACugYk+13k= -----END CERTIFICATE----- </textarea>
											</div>
											<div class="note-description mt_20">
												<p class="mb_10">NOTE : <span class="font_size_12">Format of the certificate:</span></p>
												<div class="cert-formate">-----BEGIN CERTIFICATE-----
													<br> XXXXXXXXXXXXXXXXXXXXXXXXXXX
													<br> -----END CERTIFICATE----- </div>
											</div>
											<div class="w-100 d-flex mt_40"> <a href="#" class="btn btn_primary mr_16">Upload</a> <a href="#" class="btn btn_primary ">Reset</a> </div>
										</div>
									</div>
								</div>
								<div class="tab-pane fade" id="custom-message" role="tabpanel" aria-labelledby="custom-message">
									<h4 class="font_size_40 mx-auto text-left">Customize messages shown to users</h4>
									<div class="click-text mt_10 mb_10 font_size_12">[ <a href="#" class="text_primary">Click here</a> to know how this is useful. ]</div>
									<div class="row mt_40 custom-certificate">
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">User creation disabled message <span>*</span> :</label>
											<div class="position-relative">
												<textarea rows="10" cols="5" width="100%" name="saml_public_x509_certificate" placeholder="User creation disabled message" required=""> We could not sign you in. Please contact your Administrator. </textarea>
											</div>
										</div>
										<div class="col-md-6">
											<label for="disabledTextInput" class="form-label">Restricted Domain error message <span>*</span> :</label>
											<div class="position-relative">
												<textarea rows="10" cols="5" width="100%" name="saml_public_x509_certificate" placeholder="Restricted Domain error message" required=""> You are not allowed to login. Please contact your Administrator. </textarea>
											</div>
											
										</div>
										<div class="w-100 mt_40 text-center"> <a href="#" class="btn btn_primary ">Save Setting</a> </div>
									</div>
								</div>
								<div class="tab-pane fade" id="account-info" role="tabpanel" aria-labelledby="account-info">
									<div class="row">
										<div class="col-md-6">
											<h4 class="font_size_60 mx-auto text-left mt_40">Your Profile</h4> </div>
										<div class="col-md-6">
											<div class="w-100 d-flex mt_30 justify-content-end"> <a href="#" class="btn btn_primary mr_16">Confirm License</a> <a href="#" class="btn btn_primary ">Get License Keys</a> </div>
										</div>
									</div>
									<div class="row mt_40">
										<div class="profile-table">
											<table class="table">
												<tbody>
													<tr>
														<td> miniOrange Account Email </td>
														<td> sidney@pbergo.com </td>
													</tr>
													<tr>
														<td> Customer ID </td>
														<td> 130378 </td>
													</tr>
												</tbody>
											</table>
										</div>
										<div class="w-100 d-flex mt_30"><a href="#" class="btn btn_primary ">Remove Account</a> </div>
									</div>
								</div>
							</div>
							<!-- Tabs End Here -->
						</div>
					</div>
				</main>
			<!-- </div>
		</div>
	</div> -->
</div>
</template>
<script>
    export default {
        name: "sso_configuration"
    }
</script>